import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  href: string;
  className?: string;
  target?: string;
  onLinkClick?: () => void;
}
const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full text-white bg-cta hover:bg-cta-dark shadow-[0_10px_28px_-10px_rgba(22,163,74,0.6)] transition-[background-color,box-shadow] duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-canvas';
export function Button({
  children,
  href,
  className = '',
  target,
  onLinkClick
}: ButtonProps) {
  return <motion.a href={href} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.16,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-54" data-mp="287tc5ttzaxdb">
      {children}
    </motion.a>;
}